<template>
  <div class="main_box">
    <!-- 头部搜索栏 -->
    <div class="bg-max" style="background-color: #f8f8f8; ">
      <div class="top_box max_width">
        <img class="logo" src="./assets/logo.png"></img>
        <div class="help">帮助中心</div>
        <el-input class="input" placeholder="搜索你想知道的关键词" v-model="input_str" @keyup.enter.native="getProblemDetails(1,input_str)"></el-input>
        <div style="height: 45px;width: 60px;background-color: #0091ff;float: right;display: flex;align-items: center;justify-content: center;cursor: pointer;" @click="getProblemDetails(1,input_str)">
          <i class="el-icon-search" style="color: #fff;font-size: 30px;"></i>
        </div>
      </div>
    </div>
    
    <!-- tabs栏 -->
    <div class="bg-max" style="background-color: #e5f2ff;">
      <div class="tabs_box max_width" >
        <div class="tabs_item" v-for="(item,index) in tabs_data" :style="item.click ? 'background-color: #fff;':'background-color: #e5f2ff'" :key="index" @click="clickTabs(index)">
          {{item.name}}
        </div>
      </div>
    </div>
    
    <!-- 左右列表内容 -->
    <div class="content_box max_width" v-loading="loding">
      
      <!-- 左侧列表 -->
      <div class="lift_list">
        <el-collapse v-model="activeNames" accordion @change="handleChange" style="border-bottom: 0;">
          <el-collapse-item :name="index" v-for="(item,index) in left_list_data" :key="index" class="liet_item" size="medium ">
            <template slot="title">
              <span class="left_list_titel" >{{item.name}}</span>
            </template>
            <div class="lift_list_item" v-for="(i_item,i_index) in item.child" :key="i_index" :style="i_item.click ? 'background-color: #e5f2ff;color: #1d1c1c;' : ''" @click="setLiftListItemClick(index,i_index)">
              <div style="padding: 5px 15px;">{{i_item.name}}</div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      
      <!-- 右侧列表 -->
      <div class="right_list" v-if="!show_rich_text">
        <div class="right_list_top">
          {{right_list_titel.name}}
        </div>
        <div class="right_list_content" v-for="(item,index) in right_list_data" :key="index" @click="getRichText(item.id)">
          <i class="el-icon-video-play" style="font-size: 20px;margin: 3px 20px 0 0;" v-if="item.type == 'video'"></i>
          <div v-html="keyword(item.title)"></div>
        </div>
        <div class="right_list_bottom">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="help_list.length"
            :page-size='6'
            @current-change="setRightData">
          </el-pagination>
        </div>
      </div>
      
      <!-- 右侧详情内容 -->
      <div class="right_list" v-else>
       <div class="right_list_top">
          <el-breadcrumb separator="/" style="font-size: 20px;">
            <el-breadcrumb-item><el-link type="primary" @click="clickBreadcrumb(right_list_titel.id)">{{right_list_titel.name}}</el-link></el-breadcrumb-item>
            <el-breadcrumb-item><el-link disabled>问题正文</el-link></el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div style="width: 100%;margin-top: 30px;" v-html="rich_text"></div>
      </div>
    </div>
    
    <!-- 底部栏 -->
    <div class="bg-max" style="border-top: 2px solid #0091ff;margin-top: 70px;">
      <div class="bottom_box max_width">
        <div class="bottom_left_box">
          <div style="display: flex;flex-direction: row;color: #4b4b4b;">
            Copyright © Listeneer
            <el-link href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="margin-left: 10px;">粤ICP备11101043号-1</el-link>
            <el-link href="https://uweb.umeng.com/v1/login.php?siteid=3671559" type="primary" target="_blank" style="margin-left: 10px;">站长统计</el-link>
          </div>
          <el-link style="color: #4b4b4b;margin-top: 20px;cursor: pointer;" :underline="false" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602005194" target="_blank">
            <span style="display: flex;flex-direction: row;align-items: center;">
              <img src="./assets/beian.png"></img>
              粤公网安备 44030602005194号
            </span>
          </el-link>
        </div>
        <div class="bottom_qrcode_box1">
          <img src="./assets/qr_code1.jpg" style="width: 77px;height: 77px;"></img>
          <div class="qr_code_titel1">打开微信扫一扫</div>
          <div class="qr_code_titel2">咨询微信客服</div>
        </div>
        <div class="bottom_qrcode_box2">
          <img src="./assets/qr_code2.jpg" style="width: 77px;height: 77px;"></img>
          <div class="qr_code_titel1">打开QQ扫一扫</div>
          <div class="qr_code_titel2">咨询QQ客服</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters:{
    
  },
  data(){
    return{
      activeNames: [0],
      right_list_titel: {},
      show_rich_text: false,
      rich_text:'',
      input_str: '',
      key_str:'',
      tabs_data:[],
      left_list_data: [],
      right_list_data:[],
      help_list:[],
      loding: false
    }
  },
  mounted() {
    console.log('OnLoad');
    this.getListData();
    
    // 友盟统计添加
    const script = document.createElement("script");
    //该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.src = "https://s23.cnzz.com/z_stat.php?id=3671559&web_id=3671559";
    script.language = "JavaScript";
    document.body.appendChild(script);
  },
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  },
  methods: {
    keyword(str){
      let key = this.key_str
      
      if(key != ''){
        str= str.replace(new RegExp(key,'g'),`<span style="color:#0091ff">${key}</span>`)
        console.log(str);
      }
      return str
    },
    formatRichText(html) { //控制小程序中图片大小
      let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
        return match;
      });
      newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
        return match;
      });
      newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"');
      newContent = newContent.replace(/\<video/gi, '<video style="width:100%;display:inline-block;margin:10rpx auto;"');
      return newContent;
    },
    clickTabs(index,type){
      //渲染样式
      this.tabs_data.forEach((item,i) => {
        if(index == i){
          item.click = true
          if(type != 1){
            this.updateUrl('device_id',item.id)  //更新url
            this.updateUrl('p_id','')
          }
        }
        else{
          item.click = false
        }
      })
      
      //获取数据
      if(type == 1){  //分享渲染
        this.getProblem(1)
      }
      else{
        this.getProblem()
      }
    },
    
    clickBreadcrumb(id){
      this.show_rich_text = false
      let mi = 0
      let ii = 0
      this.left_list_data.forEach((item,index) => {
        item.child.forEach((i_item,i_index) => {
          if(i_item.id == id){
            mi = index
            ii = i_index
          }
        })
      })
      console.log(mi,ii);
      this.setLiftListItemClick(mi,ii)
    },
    
    handleChange(val) {
      // console.log(val);
    },
    
    getListData(){
      this.loding = true
      this.$get('device',{}).then(res => {
        console.log("获取的设备数据",res);
        this.loding = false
        if(res.data.length){
          let data = res.data
          data.forEach((item,index) => {
            if(index == 0){
              item.click = true
              this.updateUrl('device_id',item.id)  //更新url
            }else{
              item.click = false
            }
          })
          this.tabs_data = data
          console.log("tabs_data",this.tabs_data);
          if(this.GetQueryString('device_id')){  //分享显示
            this.setData();
          }else{
            this.getProblem();
          }
        }else{
          // this.notifyError('型号列表空')
        }
      }).catch(err=> {
        console.log(err);
        this.loding = false
        let msg = err ? err : '请求失败'
        this.notifyError(msg)
      })
    },
    
    GetQueryString(name){
       var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
       var r = window.location.search.substr(1).match(reg);
       if(r!=null)return  unescape(r[2]); return null;
    },
    
    updateUrl( key, value){
      var newurl = this.updateQueryStringParameter(key, value)
      //向当前url添加参数，没有历史记录
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    },
 
    updateQueryStringParameter(key, value) {
      var uri = window.location.href
      // if(!value) {
      //   return uri;
      // }
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
      }
      else {
        return uri + separator + key + "=" + value;
      }
    },

    
    setData(){
      let device_id = this.GetQueryString('device_id')
      let m_index = 0
      this.tabs_data.forEach((item,index) => {
        if(device_id == item.id){
          m_index = index
        }
      })
      this.clickTabs(m_index,1) //点击对应的机型
    },
    
    getProblem(type){
      let device_id = 0
      this.tabs_data.forEach(item => {
        if(item.click){
          device_id = item.id
        }
      })
      let postdata = {
        device_id: device_id
      }
      this.loding = true
      this.$post('category',postdata).then(res => {
        this.loding = false
        console.log("获取的问题数据",res);
        if(res.data.length != 0){
          let data = res.data
          data.forEach((item,index) => {
            item.child.forEach((i_item,i_index) => {
              i_item.click = false
              if(index == 0 && i_index == 0){
                i_item.click = true
                if(type != 1){
                  this.updateUrl('class_id',i_item.id)  //更新url
                }
              }
            })
          })
          this.left_list_data = res.data
          console.log('left_list_data',this.left_list_data);
          if(type == 1){  //分享进入 渲染数据
            this.setProblem();
          }
          else{
            this.activeNames = [0] //默认打开第一栏
            this.getProblemDetails(1);  //获取问题详情
          }
        }
        else{
          // this.notifyError('问题列表空')
        }
      }).catch(err => {
        this.loding = false
        console.log(err);
        let msg = err ? err : '请求失败'
        this.notifyError(msg)
      })
    },
    
    setProblem(){
      let class_id = this.GetQueryString('class_id')
      this.left_list_data.forEach((item,index) => {
        item.child.forEach((i_item,i_index) => {
          if(i_item.id == class_id){
            this.activeNames = [index] //默认打开第index栏
            this.setLiftListItemClick(index,i_index,1)
          }
        })
      })
    },
    
    getProblemDetails(page,data,type){
      let keyword = data ? data : ''
      let id = 0
      let titel = ''
      let video_flag = false
      this.show_rich_text = false //显示列表
      this.left_list_data.forEach(item => {
        item.child.forEach(i_item => {
          if(i_item.click){
            id = i_item.id
            titel = i_item.name
            if(titel == '使用操作视频'){
              video_flag = true
            }
          }
        })
      })
      let device_id = 0
      this.tabs_data.forEach(item => {
        if(item.click){
          device_id = item.id
        }
      })
      let postdata = {
        class_id: id,
        keyword : keyword,
        device_id: keyword == '' ? keyword : device_id,
        page: page,
        pageSize: 6
      }
      this.loding = true
      this.$post('help/list',postdata).then(res => {
        this.loding = false
        console.log("获取问题详情",res);
        if(res.data.length != 0){
          this.help_list = res.data
          this.key_str = this.input_str
          this.help_list.forEach(item => {
            if(video_flag){
              item.type = 'video' 
            }
            else{
              item.type = '' 
            }
          })
          this.right_list_data = this.help_list
          if(this.GetQueryString('p_id')){ //分享渲染
            this.getRichText(this.GetQueryString('p_id'))
          }
        }else{
          // this.notifyError('问题详情数据空')
          this.right_list_data = []
          this.help_list = []
        }
        this.right_list_titel.name = titel
        this.right_list_titel.id = id
      }).catch(err => {
        this.loding = false
        console.log(err);
        this.notifyError(err ? err : '请求失败')
      })
    },
    
    getRichText(id){
      this.updateUrl('p_id',id)
      let postdata = {
        id: id
      }
      this.$post('help/detail',postdata).then(res => {
        console.log("获取富文本的数据",res);
        if(res.data){
          this.show_rich_text = true
          this.setBreadcrumb(res.data.help_class_id);
          this.rich_text = this.formatRichText(res.data.content)
        }else{
          // this.notifyError('富文本数据空')
        }
      }).catch(err => {
        console.log(err);
        this.notifyError(err ? err : '请求失败')
      })
    },
    
    setBreadcrumb(id){
      this.left_list_data.forEach(item => {
        item.child.forEach(i_item => {
          if(id == i_item.id){
            this.right_list_titel.name = i_item.name
            this.right_list_titel.id = i_item.id
          }
        })
      })
    },
    
    setRightData(index){
      this.getProblemDetails(index)
    },
    
    notifyError(msg){
      this.$notify.error({
        title: '错误',
        message: msg
      })
    },
    
    setLiftListItemClick(mi,ii,type){
      //渲染
      this.left_list_data.forEach((item,index) => {
        item.child.forEach((i_item,i_index) => {
          i_item.click = false
          if(i_index == ii && index == mi){
            i_item.click = true
            this.activeNames = [index]
            if(type != 1){
              this.updateUrl('class_id',i_item.id)  //更新url
              this.updateUrl('p_id','')
            }
          }
        })
      })
      this.input_str = ''
      this.key_str = ''
      //获取数据
      if(type == 1){  //分享渲染
        this.getProblemDetails(1,'',1);
      }
      else{
        this.getProblemDetails(1);
      }
    },
  }
}
</script>

<style>
body{
  padding: 0;
  margin: 0;
}
.el-collapse-item__header:hover{
  background: #f8f8f8;
}
.main_box{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.max_width{
  width: 1200px;
}
.top_box{
  height: 152px;
  padding: 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.logo{
  width: 201px;
  height: 70px;
}
.input{
  width: 468px;
  margin-left: 260px;
}
.el-input__inner{
  height: 45px;
  border-radius: 0;
}
.tabs_box{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0;
  height: 60px;
}
.tabs_item{
  height: 100%;
  padding: 0 30px;
  color: #4c4c4c;
  font-size: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.tabs_item:hover{
  background-color: #fff !important;
}
.bg-max{
  width: 100%; 
  display: flex;
  align-items: center;
  justify-content: center;
}
.help{
  border-left: 1px solid #0091ff;
  margin-left: 22px;
  font-size: 21px;
  color: #0091ff;
  width: 200px;
  padding-left: 20px;
}
.content_box{
  margin-top: 20px;
  display: flex;
  flex-direction: row;
}
.lift_list{
  width: 288px;
  display: flex;
  flex-direction: column;
}
.liet_item{
  
}
.liet_item:hover{
  background-color: #f8f8f8;
}
.lift_list_item{
  width: 288px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #5d5a5a;
  font-size: 15px;
  cursor: pointer;
}
.lift_list_item:hover{
  background-color: #e5f2ff;
}
.left_list_titel{
  font-weight: bold;
  color: #5d5a5a;
  font-size: 16px; 
  width: 100%;
}
.left_list_titel:hover{
  background-color: #f8f8f8;
}
.right_list{
  width: 854px;
  min-height: 450px;
  margin-left: 30px;
  border: 1px solid #f1f1f1;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
}
.right_list_top{
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #0091ff;
  font-size: 17px;
}
 .right_list_content{
   width: 100%;
   height: 60px;
   display: flex;
   flex-direction: row;
   align-items: center;
   border-bottom: 1px solid #f1f1f1;
   font-size: 17px;
   color: #5d5a5a;
 } 
 .right_list_content:hover{
   color: #0091ff;
   cursor: pointer;
 }
 .right_list_bottom{
   width: 100%;
   height: 80px;
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: flex-end;
 }
 .bottom_box{
   display: flex;
   height: 140px;
   flex-direction: row;
   align-items: center;
 }
 .bottom_qrcode_box1{
   width: 87px;
   height: 113px;
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .bottom_qrcode_box2{
   width: 87px;
   height: 113px;
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-left: 30px;
 }
 .qr_code_titel1{
   font-size: 10px;
   color: #5d5a5a;
 }
 .qr_code_titel2{
   font-size: 10px;
   color: #0091ff;
 }
 .bottom_left_box{
   width: 1000px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue